<!-- eslint-disable -->
<template lang="pug">
		.settings(v-if='settings')
				span
						| {{ $i18n.t('trainer.trainer_gameFormSetting_partOfSpeech') }}:
						| {{ settings.partOfSpeech ? $i18n.t('trainer.trainer_gameFormSetting_' + settings.partOfSpeech) : ''}}
				br
				span
						| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
						| {{ settings.amountOfExamples}}
				br
				span
						| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfVariants') }}:
						| {{ settings.amountOfVariants }}
				br
				slot
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from "../../../utils/trainer/gamePreviewMixin";

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework'
            }
        }
    }
</script>
